import React from 'react';

import {Icon, Stack} from '@edna/components/primitives';

import {FacebookIcon} from 'src/icons';

import * as S from './style';

type TProps = {
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  isLoading?: boolean;
  className?: string;
  children?: React.ReactNode;
};

export const FacebookButton = React.memo<TProps>(({children, isLoading, onClick, className}) => (
  <S.FacebookButton loading={isLoading} onClick={onClick} className={className}>
    <Stack direction="ROW" size="2" align="center">
      <Icon as={FacebookIcon} size="20px" />
      {children}
    </Stack>
  </S.FacebookButton>
));
